module.exports = __webpack_public_path__ + "img/logo.bf1ab71e.png";